import * as XLSX from 'xlsx';
import { triggerDownload, today } from './downloadHelpers';

export function exportCostaRicaCsv(facturas) {
  const headers = ['Fecha', 'Emisor ID', 'Emisor', 'Receptor', 'Moneda', 'Total Gravado', 'Total IVA', 'Total Comprobante', 'Número Consecutivo', 'Clave'];
  const rows = facturas.map(f => [
    f.fecha,
    f.emisorId,
    f.emisorNombre,
    f.receptorNombre,
    f.moneda,
    f.totalGravado.toFixed(2),
    f.totalImpuesto.toFixed(2),
    f.totalComprobante.toFixed(2),
    f.numeroConsecutivo,
    f.clave,
  ]);
  const csv = [headers, ...rows]
    .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  triggerDownload(
    new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' }),
    `compras_cr_${today()}.csv`
  );
}

export function exportCostaRicaExcel(facturas) {
  const wb = XLSX.utils.book_new();

  const summaryRows = [
    ['Fecha', 'Emisor ID', 'Emisor', 'Receptor', 'Moneda', 'Total Gravado', 'Total IVA', 'Total Comprobante', 'Número Consecutivo', 'Clave'],
    ...facturas.map(f => [
      f.fecha, f.emisorId, f.emisorNombre, f.receptorNombre, f.moneda,
      f.totalGravado, f.totalImpuesto, f.totalComprobante, f.numeroConsecutivo, f.clave,
    ]),
  ];
  const ws1 = XLSX.utils.aoa_to_sheet(summaryRows);
  ws1['!cols'] = [12, 14, 32, 32, 8, 16, 16, 18, 22, 52].map(w => ({ wch: w }));
  XLSX.utils.book_append_sheet(wb, ws1, 'Compras');

  const itemRows = [
    ['Clave', 'Fecha', 'Emisor', 'N° Línea', 'Cantidad', 'Unidad', 'Detalle', 'Precio Unitario', 'Total Línea'],
    ...facturas.flatMap(f =>
      f.items.map(item => [
        f.clave, f.fecha, f.emisorNombre,
        item.numLinea, item.cantidad, item.unidad, item.detalle,
        item.precioUnitario, item.montoTotalLinea,
      ])
    ),
  ];
  const ws2 = XLSX.utils.aoa_to_sheet(itemRows);
  ws2['!cols'] = [52, 12, 32, 8, 10, 8, 50, 16, 16].map(w => ({ wch: w }));
  XLSX.utils.book_append_sheet(wb, ws2, 'Detalle Líneas');

  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  triggerDownload(
    new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `compras_cr_${today()}.xlsx`
  );
}
